import { Button, Modal } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IoMdArrowBack } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AppLayout from '../../components/AppLayout/AppLayout'
import { AppDispatch } from '../../store'
import UploadPrivacyPolicy from './UploadPrivacyPolicy'
import { fetchUploadFile } from './privacyPolicySlice'

function PrivacyPolicy () {
  const { t } = useTranslation('privacyPolicy')
  const navigate = useNavigate()
  const dispatch:AppDispatch = useDispatch()
  const [filePDFs, setFilePDFs] = useState<{[lang: string]: File | null}>({de: null, en: null, fr: null, it: null, uk: null})
  const LANGUAGES = ['de', 'en', 'fr', 'it', 'uk']
  const [openIsFileDropModal, setOpenIsFileDropModal] = useState<Boolean>(false)

  
  function backToOrganizationsList(): void {
    if (Object.entries(filePDFs).every(([key, value]) => value === null)) {
      navigate(`/`)
    } else {
      setOpenIsFileDropModal(true)
    }
  }


  function continueWithSave() {
    LANGUAGES.forEach((lang) => {
      if (filePDFs[lang]) {
        const data = new FormData()
        data.append(`privacy-policy_${lang}`, filePDFs[lang] as File)
        uploadFile(data, lang)
      }
    })
    setOpenIsFileDropModal(false)
    navigate(`/`)
  }

  function uploadFile(data : FormData, lang: string) {
    dispatch(fetchUploadFile({ data, lang }))
  }

  return (
    <AppLayout contentClassName='filePage'>
      <div className='mb-1rem'>
        <Button type='link' className='text-middle' onClick={() => backToOrganizationsList()}>
          <IoMdArrowBack/>
          <span>{t('Back', { ns: 'common' })}</span>
        </Button>
      </div>

      <UploadPrivacyPolicy
        filePDFs={filePDFs} setFilePDFs={setFilePDFs} uploadFile={uploadFile}
      />

      <Modal
        centered
        title={t("File backups", { ns: 'common'})}
        open={!!openIsFileDropModal}
        destroyOnClose={true}
        footer={[
          <div className='d-flex d-flex-right'>
            <Button 
              onClick={() => {setOpenIsFileDropModal(false)}}
            >
              {t('Cancel', { ns: 'common'})}
            </Button>
            <Button 
              type="primary" 
              onClick={() => {
                setOpenIsFileDropModal(false)
                navigate(`/`)
              }}
            >
              {t('Continue without saving', { ns: 'common'})}
            </Button>
            <Button 
              type="primary" 
              onClick={continueWithSave}
            >
              {t('Save', { ns: 'common'})}
            </Button>
          </div>
        ]}
      >
        <div className='d-flex d-flex-center d-flex-middle'>
          {t("The privacy policy contain unsaved changes.")}
        </div>
        <div className='d-flex d-flex-center d-flex-middle'>
          {t("Would you like to save your progress?", { ns: 'common'})}
        </div>
      </Modal>
    </AppLayout>    
  )
}

export default PrivacyPolicy
